import React from 'react';

/**
 * PlanBadge Component
 * Displays a user's subscription plan with color-coded badge
 * 
 * @param {string} plan - User's subscription plan ('pro', 'essential', 'free')
 * @param {string} className - Additional CSS classes
 */
const PlanBadge = ({ plan, className = '' }) => {
  // Don't show badge for free tier
  if (!plan || plan === 'free' || plan === 'free_trial') {
    return null;
  }

  // Normalize plan name
  const normalizedPlan = plan.toLowerCase();

  // Define badge styles based on plan
  const badgeStyles = {
    pro: {
      bg: 'bg-amber-100',
      text: 'text-amber-800',
      label: 'PRO'
    },
    essential: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      label: 'Essential'
    }
  };

  const style = badgeStyles[normalizedPlan];

  // If plan not recognized, don't show badge
  if (!style) {
    return null;
  }

  return (
    <span 
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${style.bg} ${style.text} ${className}`}
      title={`${style.label} Plan`}
    >
      {style.label}
    </span>
  );
};

export default PlanBadge;

